import reportsDictionary from 'Dictionaries/reports/reportsDictionary';
import { REPORTS_CATEGORIES } from 'Dictionaries/reports/reportsCategories.js';
import ReportsApi from 'api/reports/reports';

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

const pricincLevelV3Code = 3;
const pricincLevelV5Code = 5;

const highestPricingPlanCodes = ['advanced', 'enterprise', 'evolution', 'elite'];
const highestLicenceCodes = ['pack_all_included'];

export default {
    data() {
        return {
            loadingBtnFavorite: false,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
        isFavorite() {
            return this.report.favorite;
        },
        contentTooltipFavorite() {
            return this.isFavorite
                ? this.$t.__('common.labels.remove_from_favorites')
                : this.$t.__('common.labels.add_to_favorites');
        },
        showCategory() {
            return (
                this.report.category &&
                Object.keys(REPORTS_CATEGORIES).includes(this.report.category)
            );
        },
        getColorTag() {
            return REPORTS_CATEGORIES[this.report.category]?.color;
        },
        getLabelCategory() {
            return this.$t.__(REPORTS_CATEGORIES[this.report.category]?.label);
        },
    },
    methods: {
        getLuzmoReportsAvailableForAReport(
            userPricingLevel,
            userPricingPlan,
            userLicence,
            reportCode,
        ) {
            const reportsAvailable = [];
            for (const report of reportsDictionary) {
                if (this.checkOldReportCode(reportCode, report)) {
                    if (this.checkReportPricingLevel(userPricingLevel, report)) {
                        //Pour le pricing level 3, il n'y a pas de pricing plan ni de licence
                        if (userPricingLevel === pricincLevelV3Code) {
                            reportsAvailable.push({ ...report, upsell: false });
                        } else {
                            if (this.checkReportPricingPlan(userPricingPlan, report)) {
                                reportsAvailable.push({
                                    ...report,
                                    upsell: !this.checkReportLicence(userLicence, report),
                                });
                            } else if (
                                this.checkUserPricingPlanIsLowerThanHighest(userPricingPlan)
                            ) {
                                reportsAvailable.push({ ...report, upsell: true });
                            }
                        }
                    } else if (this.checkUserPricingLevelIsLowerThanHighest(userPricingLevel)) {
                        reportsAvailable.push({ ...report, upsell: true });
                    }
                }
            }

            return reportsAvailable;
        },
        checkOldReportCode(reportCode, report) {
            return report.oldReportsCode.includes(reportCode);
        },
        checkReportPricingLevel(userPricingLevel, report) {
            return report.pricingLevels.includes(userPricingLevel);
        },
        checkReportPricingPlan(userPricingPlan, report) {
            return report.pricingPlans.includes(userPricingPlan);
        },
        checkReportLicence(userLicence, report) {
            return report.licenses.includes(userLicence);
        },
        checkUserPricingLevelIsLowerThanHighest(userPricingLevel) {
            return userPricingLevel < pricincLevelV5Code;
        },
        checkUserPricingPlanIsLowerThanHighest(userPricingPlan) {
            return !highestPricingPlanCodes.includes(userPricingPlan);
        },
        checkUserLicenceIsLowerThanHighest(userLicence) {
            return !highestLicenceCodes.includes(userLicence);
        },
        toggleFavorite() {
            this.loadingBtnFavorite = true;
            const newFavoriteState = !this.isFavorite;
            const apiCall = this.isFavorite
                ? ReportsApi.unmarkAsFavorite(this.report.id)
                : ReportsApi.markAsFavorite(this.report.id);

            apiCall
                .then(() => {
                    // Method called from ReportsDashboard.vue or ReportsListingTableRow.vue (manage by event emit or directly)
                    this.onFavoriteToggleSuccess(newFavoriteState);
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('common.labels.error_retry'),
                    });
                    throw error;
                })
                .finally(() => {
                    this.loadingBtnFavorite = false;
                });
        },
    },
};
